import { createFileRoute, redirect } from "@tanstack/react-router";
import { homePath } from "../../app/home";
import { lastScope } from "../../app/scope";

export const Route = createFileRoute("/_authed/$org/")({
  beforeLoad: ({ context, params }) => {
    throw redirect({ href: homePath(params.org, lastScope(context.session.user.id).project(params.org)) });
  },
});
